'use client';
import { createTypography } from '@s7/base';
import { COMPONENT_ID, defaultButtonTypographyProps } from './ButtonTypography.contract.js';

var ButtonTypography = createTypography({
    componentId: COMPONENT_ID,
    defaultProps: defaultButtonTypographyProps
});

export { ButtonTypography };
